function initDrawerToggles() {
  const toggleButtons = document.querySelectorAll('[data-drawer-popup-toggle]');

  toggleButtons.forEach((toggleButton) => {
    const toggleArrow = toggleButton.querySelector('.arrow-feather');
    const drawerPopupContainer = toggleButton.closest('[data-drawer-popup]');
    const bodyElement = drawerPopupContainer?.querySelector('[data-drawer-popup-body]');
    if (!bodyElement) return;

    const bodyHeight = bodyElement.scrollHeight;

    // Check if open by default
    if (drawerPopupContainer.hasAttribute('data-open')) {
      bodyElement.style.height = bodyHeight + 'px';
      toggleArrow.style.transform = 'rotate(180deg)';
      drawerPopupContainer.style.gap = '14px';
      drawerPopupContainer.classList.add('py-3');
      toggleButton.querySelector('.arrow-feather').style.top = '1px';
    } else {
      bodyElement.style.height = '0px';
      toggleArrow.style.transform = 'rotate(0deg)';
      drawerPopupContainer.style.gap = '0px';
      drawerPopupContainer.classList.remove('py-3');
      toggleButton.querySelector('.arrow-feather').style.top = '-1px';
    }

    toggleButton.addEventListener('click', () => {
      if (bodyElement.style.height != '0px') {
        expandInfo({ bodyElement, toggleButton, drawerPopupContainer, toggleArrow });
      } else {
        collapseInfo({ bodyElement, toggleButton, drawerPopupContainer, bodyHeight, toggleArrow });
      }
    });
  });
}

function expandInfo({ bodyElement, toggleButton, drawerPopupContainer, toggleArrow }) {
  bodyElement.style.height = '0px';
  toggleArrow.style.transform = 'rotate(0deg)';
  toggleButton.querySelector('.arrow-feather').style.top = '-1px';
  drawerPopupContainer.style.gap = '0px';
  drawerPopupContainer.classList.remove('py-3');
}

function collapseInfo({ bodyElement, toggleButton, drawerPopupContainer, bodyHeight, toggleArrow }) {
  bodyElement.style.height = bodyHeight + 'px';
  toggleArrow.style.transform = 'rotate(180deg)';
  toggleButton.querySelector('.arrow-feather').style.top = '1px';
  drawerPopupContainer.style.gap = '14px';
  drawerPopupContainer.classList.add('py-3');
}

document.addEventListener('DOMContentLoaded', initDrawerToggles);
document.addEventListener('cart:updated', initDrawerToggles);
